import { Link } from 'react-router-dom';
import type { Video } from '@/types/video';
import { formatViews } from '@/utils/format';

export default function VideoCard({ video, rank }: { video: Video; rank?: number }) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-video w-full overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} 封面`}
          title={`${video.title} - 涩涩视频`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
        {typeof rank === 'number' && (
          <span className="absolute left-2 top-2 flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 text-sm font-bold text-background-50">
            {rank}
          </span>
        )}
        <span className="absolute right-2 top-2 rounded-md bg-black/60 px-2 py-0.5 text-xs font-medium text-background-50">
          {video.categoryName}
        </span>
        <span className="absolute bottom-2 right-2 rounded-md bg-black/70 px-2 py-0.5 text-xs font-medium text-background-50">
          {video.duration}
        </span>
        <span className="absolute bottom-2 left-2 flex items-center gap-1 rounded-md bg-black/60 px-2 py-0.5 text-xs text-background-50">
          <i className="ri-eye-line text-xs" />
          {formatViews(video.views)}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill ml-0.5 text-2xl" />
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          {video.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span className="whitespace-nowrap">{video.region}</span>
          <span className="text-background-400">·</span>
          <span className="whitespace-nowrap">{video.year}</span>
          <span className="text-background-400">·</span>
          <span className="whitespace-nowrap">{video.genre}</span>
        </div>
        <div className="mt-2 flex items-center gap-1 text-xs text-foreground-400">
          <i className="ri-calendar-line" />
          <span>{video.uploadDate}</span>
        </div>
      </div>
    </Link>
  );
}